import { CheckboxGroup } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { SearchQualityCheckStatus } from "@graphql";

type QualityCheckStatusSelectorProps = {
  items: string[];
  value: string[];
  qualityCheckName: string;
  onChange: (value: string[]) => void;
};

export function QualityCheckStatusSelector(props: QualityCheckStatusSelectorProps) {
  const options = props.items.map((v) => {
    let label = "";
    if (v === "MRSA_updateOverdue") {
      label = "MRSA-uppdatering förfallen";
    } else if (props.qualityCheckName === "Referenser") {
      label = locale.searchQualityCheckReferenceStatus[v];
    } else if (props.qualityCheckName === "Referenser Nationella") {
      label = locale.searchQualityCheckReferenceNationalStatus[v];
    } else {
      label = locale.searchQualityCheckStatus[v as SearchQualityCheckStatus];
    }

    return {
      label: label,
      value: v
    };
  });

  return (
    <CheckboxGroup
      label={locale.selectQCStatus}
      value={props.value}
      options={options}
      onChange={(event, value) => props.onChange(value)}
    />
  );
}
